/**
 * Utilitários para sanitização de dados para NFe/NFCe
 * Remove caracteres especiais que não são aceitos no XML fiscal
 */

/**
 * Remove caracteres especiais de CPF/CNPJ (pontos, hífens, barras)
 * Preserva letras (CNPJ alfanumérico) e converte para maiúsculas
 * @param {string} document - CPF/CNPJ formatado (ex: "123.456.789-00" ou "12.ABC.345/0001-00")
 * @returns {string} Documento sem formatação (ex: "12345678900" ou "12ABC34500010X")
 */
function sanitizeDocument(document) {
  if (!document) return "";
  return String(document).replace(/[^0-9A-Za-z]/g, '').toUpperCase();
}

/**
 * Remove caracteres especiais de CNPJ (pontos, hífens, barras)
 * Preserva letras (CNPJ alfanumérico) e converte para maiúsculas
 * @param {string} cnpj - CNPJ formatado (ex: "12.ABC.345/0001-00")
 * @returns {string} CNPJ sem formatação (ex: "12ABC34500010X")
 */
function sanitizeCnpj(cnpj) {
  if (!cnpj) return "";
  return String(cnpj).replace(/[^0-9A-Za-z]/g, '').toUpperCase();
}

/**
 * Remove caracteres especiais de CPF (pontos, hífens)
 * @param {string} cpf - CPF formatado (ex: "123.456.789-00")
 * @returns {string} CPF apenas com números (ex: "12345678900")
 */
function sanitizeCpf(cpf) {
  if (!cpf) return "";
  return String(cpf).replace(/[^\d]/g, '');
}

/**
 * Remove caracteres especiais de CEP (hífens, pontos, espaços)
 * @param {string} cep - CEP formatado (ex: "29145-653")
 * @returns {string} CEP apenas com números (ex: "29145653")
 */
function sanitizeCep(cep) {
  if (!cep) return "";
  return String(cep).replace(/[^\d]/g, '');
}

/**
 * Remove caracteres especiais de telefone (parênteses, espaços, hífens)
 * @param {string} phone - Telefone formatado (ex: "(27) 9 9224-8111")
 * @returns {string} Telefone apenas com números (ex: "27992248111")
 */
function sanitizePhone(phone) {
  if (!phone) return "";
  return String(phone).replace(/[^\d]/g, '');
}

/**
 * Remove caracteres especiais de números em geral
 * Útil para campos numéricos que podem vir formatados
 * @param {string|number} value - Valor formatado
 * @returns {string} Valor apenas com números
 */
function sanitizeNumeric(value) {
  if (!value && value !== 0) return "";
  return String(value).replace(/[^\d]/g, '');
}

module.exports = {
  sanitizeDocument,
  sanitizeCnpj,
  sanitizeCpf,
  sanitizeCep,
  sanitizePhone,
  sanitizeNumeric,
};
